import { useSystemDocumentsByBqIds } from 'features/knowledgeDocumentViewer/hooks/useSystemDocumentsByBqIds'
import {
  getSystemDocumentBqId,
  getSystemDocumentDisplayTitle,
} from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'
import { useCallback, useMemo } from 'react'

/**
 * Titles for a set of cited documents, from the site's system-document list.
 * Must run inside PipelineConfigProvider + KnowledgeDocumentDataProvider,
 * like every system-document read.
 */
export const useDocumentTitles = (
  documentIds: readonly string[]
): {
  titleFor: (documentId: string) => string | undefined
  isLoading: boolean
} => {
  const { documents, isLoading } = useSystemDocumentsByBqIds([...documentIds])

  const byId = useMemo(() => {
    const map = new Map<string, string>()
    for (const document of documents ?? []) {
      const title = getSystemDocumentDisplayTitle(document)
      if (!title) continue
      const bqId = getSystemDocumentBqId(document)
      if (bqId) map.set(bqId, title)
      map.set(document.entry.id, title)
    }
    return map
  }, [documents])

  const titleFor = useCallback(
    (documentId: string) => byId.get(documentId),
    [byId]
  )
  return { titleFor, isLoading }
}
